import React, { type ReactNode } from "react";
import { FormattedMessage } from "react-intl";

export type FormattedMessageElement = React.ReactElement<
	React.ComponentProps<typeof FormattedMessage>,
	typeof FormattedMessage
>;

export const isFormattedMessageElement = (element: ReactNode): element is FormattedMessageElement => {
	return React.isValidElement(element) && (element as FormattedMessageElement).type === FormattedMessage;
};
